export default __webpack_public_path__ + "static/media/014-golf cart.b4a827b5.svg";